import 'bootstrap/scss/bootstrap.scss';
import 'styles/global.css';
import 'styles/scss/index.scss';

import wrapRootWithProvider from 'providers/wrap-root-with-provider';
import wrapPageWithProvider from 'providers/wrap-page-with-provider';
import { initialGA, addCurrentUrltoGA } from 'utils/ga';

export const wrapRootElement = wrapRootWithProvider;

export const onRouteUpdate = () => {
  initialGA();
  addCurrentUrltoGA();
};

export const wrapPageElement = wrapPageWithProvider;
